// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"a5705a71","969":"76acaeb7"}[chunkId] + ".chunk.js";
};